<script>
	import { url } from '@sveltech/routify'
	import Hamburger from '../components/Hamburger.svelte'
	import {mobile_menu} from '../store.js';
	import { fly } from 'svelte/transition';

	let menu = false;
	const md_width = 768;
	let innerWidth = 0

	mobile_menu.subscribe((val) => menu = val);

	function menu_toggle(){
		if(innerWidth < md_width && menu == true){
			menu = !menu;
			mobile_menu.set(menu);
		}
	}
</script>

<style>
	.inactive{
		  background-color: white;
		  transition: background-color 0.8s;
	  }
  </style>	


<div class:inactive={menu}>
	<nav class="text-white sticky top-0">
		<div class="bg-primary">
			<div class="max-w-6xl mx-auto">
				<div class="flex items-center md:justify-around justify-between">
					<div>
						<a class="hidden md:block" href={$url("/")}><img class="h-20" src="/img/logo.png" alt="Logó"></a>
						<a class="block md:hidden" href={$url("/")}><img class="h-20" src="/img/logoM.png" alt="Logó"></a>
						</div>
					<div class="hidden md:block">
						<a class="px-4 py-2 text-white font-bold uppercase rounded-md hover:bg-secondary hover:text-black transition duration-500" href={$url("/")}>Főoldal</a>
						<a class="px-4 py-2 font-bold uppercase rounded-md hover:bg-secondary hover:text-black transition duration-500" href={$url("/contact")}>Kapcsolat</a>
						<a class="px-4 py-2 font-bold uppercase rounded-md" href="https://www.facebook.com/uvegszerviz" target="blank"><img class="w-10 inline" src="/img/fb ikon 3.png" alt="facebook logó"></a>
						</div>
					<div class="md:hidden">
						<Hamburger/>
						</div>
					</div>
				</div>
			</div>
			{#if $mobile_menu}
			<div transition:fly="{{ y: -20, duration: 1000 }}" class="bg-white pb-4 rounded-b-3xl fixed left-0 right-0"> 
				<div class="flex flex-row">
					<div class="flex flex-col bg-primary">
						<a on:click={menu_toggle} class="block text-white pr-40 pl-4 py-2 font-bold uppercase rounded-md hover:bg-secondary hover:text-black transition duration-500" href={$url("/")}>Főoldal</a>
						<a on:click={menu_toggle} class="block text-white pr-40 pl-4 py-2 font-bold uppercase rounded-md hover:bg-secondary hover:text-black transition duration-500" href={$url("/contact")}>Kapcsolat</a>
						<a class="px-4 py-2 font-bold uppercase rounded-md" href="https://www.facebook.com/uvegszerviz" target="blank"><img class="w-10 inline" src="/img/fb ikon 3.png" alt="facebook logó"></a>
					</div>
					<div>
						<img src="/img/b_col.png" alt="logó" class="object-fill w-full h-full">
					</div>
				</div>
			</div>
			{/if}
		</nav>
	
	<main on:click={menu_toggle}>
		<slot />
	</main>
	</div>